/**
 * @version 1.16.2
 * @updated 2026-06-22
 * hokusai-gakkai Horizon — ストア固有カスタム JS（テーマ本体は極力触らない）
 * 読み込み: layout/theme.liquid → //aajhokusai.jp/cdn/shop/t/16/assets/theme-custom.js?v=93341865626274663411782210234
 *
 * Changelog:
 * - 1.16.2: composable アンカー — PC グリッド時はカードへ直接スクロール（シェル先頭に飛ばない）
 * - 1.16.1: composable アンカー — sticky ヘッダー分オフセット付きスクロール
 * - 1.16.0: composable アンカー — カルーセル内カードの DOM 解決・reposition・クリック時 preventDefault
 * - 1.15.0: hk-mo-cards — composable アンカー連携（接頭辞・ハッシュ active・カルーセル同期）
 * - 1.14.0: popup-link — モーダル前後ナビ（セクション／ページ内連動）、dialog:open を全 popup-link にバインド
 * - 1.13.0: popup-link Flickity — dialog-component へ dialog:open を直接バインド、開放後 syncChrome
 * - 1.12.9: header-menu-pc-gap — gap 調整中の ResizeObserver / overflowMinimum 連鎖を抑制
 * - 1.12.8: hk-grid-group — Flickity 二重 init を削除（connectedCallback に委譲、forced reflow 抑制）
 * - 1.12.7: popup-link Flickity — init は1回のみ、遅延は syncLayout のみ（forced reflow 抑制）
 * - 1.12.6: popup-link — dialog 開放後に HkFlickity を init（閉じた dialog 内で高さ 0 初期化される不具合）
 * - 1.12.5: hk-category-tabs — URL タブ直アクセス時の Flickity init（ready イベント + 遅延リトライ）
 * - 1.12.4: hk-category-tabs — タブ切替時に initWhenVisible + grid shell init（初回表示と同経路）
 * - 1.12.3: hk-category-tabs — Flickity refresh を tabs 初期化後に実行、矢印なし shell も init
 * - 1.12.2: hk-category-tabs — タブ表示切替後に HkFlickity.init（非表示タブの Flickity 初期化）
 * - 1.12.1: hk-category-tabs — 同一クラスの全 .hk-tab-target にアニメーション適用
 * - 1.12.0: hk-category-tabs — コンテンツ切替アニメーション（schema 連動）
 * - 1.11.0: hk-category-tabs — ターゲットクラスで hk-grid-group 表示切替（?tab=）
 * - 1.10.0: hk-category-tabs — exhibitions カテゴリタブ（?category= 連動・単体表示）
 * - 1.9.2: shopify:block:select — detail.load 時のみ HkFlickity.init（選択だけで refresh しない）
 * - 1.9.1: hk-grid-group — Flickity 利用時も HkFlickity.init を呼ぶ（デザインモード再 init 連携）
 * - 1.9.0: hk-mo-cards — URL クエリフィルタを JS で安定適用（Liquid/FPC 揺れ対策）
 - 1.8.8: hk-custom:overflow-menu-hover-keep — overflow の submenu なし項目で expanded と残留 active を除去して空白パネルを抑止
 * - 1.8.7: hk-custom:overflow-menu-hover-keep — submenu なし overflow 項目では expanded を外して空白パネルを抑止
 * - 1.8.6: hk-custom:overflow-menu-hover-keep — overflow private pointerleave を遅延クローズへ一本化し通常メニュー切替介入を撤去
 * - 1.8.5: hk-custom:overflow-menu-hover-keep — 通常メニュー hover 復帰は即時 activate に戻し transit 中のみ抑止
 * - 1.8.4: hk-custom:overflow-menu-hover-keep — 通常メニュー pointerover を直接監視して overflow からの hover 切替を補強
 * - 1.8.3: hk-custom:overflow-menu-hover-keep — overflow close 判定を実パネル領域に限定し復元ガードを切替中は停止
 * - 1.8.2: hk-custom:overflow-menu-hover-keep — 通常メニュー切替は 0.3 秒 hover 維持時のみ実行
 * - 1.8.1: hk-custom:overflow-menu-hover-keep — 通常メニュー切替時は overflow を DOM 状態ごと即時クローズ
 * - 1.8.0: hk-custom:overflow-menu-hover-keep — 開く処理を即時 hover 切替、閉じる処理だけ 0.3 秒遅延に簡略化
 * - 1.7.2: hk-custom:overflow-menu-hover-keep — activate target を menu item に正規化し default slot 判定を復元
 * - 1.7.1: hk-custom:overflow-menu-hover-keep — overflow close と通常 submenu open のタイマ競合を解消
 * - 1.7.0: hk-custom:overflow-menu-hover-keep — 通常メニュー切替を delayed activation に一本化し hover keep と分離
 * - 1.6.6: hk-custom:overflow-menu-hover-keep — 通常メニュー切替は 0.3 秒 hover 維持時のみ実行
 * - 1.6.5: hk-custom:overflow-menu-hover-keep — overflow からの斜め通過 hover は無視し、意図した通常メニュー切替だけ通す
 * - 1.6.4: hk-custom:overflow-menu — 通常サブメニュー切替を復元し、切替後に高さを再計測して文字切れを抑止
 * - 1.6.3: hk-custom:overflow-menu-hover-keep — 「さらに表示する」から overflow への斜め移動中は通常項目 hover を無視
 * - 1.6.2: hk-custom:overflow-menu — display:none / shadow DOM 強制非表示を撤回しテーマ deactivate 優先へ整理
 * - 1.6.1: hk-custom:overflow-menu — overflow 再開時に dismissed/defaultOpen 残留を解消
 * - 1.6.0: hk-custom:overflow-menu — 切替時の height 0 化をやめ clip-path 切れを防止・高さ再計測
 * - 1.5.9: hk-custom:overflow-menu — 通常項目 slot="" 対応（:not([slot]) 判定を修正）
 * - 1.5.8: hk-custom:overflow-menu — closest 修正・hydration 後再パッチ・restore ガードで重なり解消
 * - 1.5.7: hk-custom:overflow-menu — overflow-list を data 属性で display:none し重なりを解消
 * - 1.5.6: hk-custom:overflow-menu-hover-keep — さらに表示中の通常項目ホバーで overflow を確実に閉じる
 * - 1.5.5: hk-custom:overflow-menu-hover-keep — 通常項目サブメニュー開放時に overflow を確実に閉じる
 * - 1.5.4: hk-custom:header-menu-pc-gap — 広幅で minimum-reached が残り drawer になる不具合を修正
 * - 1.5.3: hk-custom:overflow-menu-hover-keep — Observer ループでフリーズ・overflow 常時表示を修正
 * - 1.5.2: hk-custom:overflow-menu-hover-keep — 「さらに表示する」時 overflowExpanded 未設定の重なりを修正
 * - 1.5.1: hk-custom:overflow-menu-hover-keep — オーバーフロー開放中の通常サブメニュー重なりを防止・ヘッダー項目で切替
 * - 1.5.0: hk-custom:header-menu-pc-gap — overflow-list 初期化前の誤計測を防止（一瞬広がって戻る不具合）
 * - 1.3.3: overflow-list reflow イベントに detail: {} を付与（null 参照エラー修正）
 * - 1.3.2: ボタン — アップロード SVG をインライン化して currentColor で着色
 * - 1.4.1: hk-grid-group — Flickity 使用時は scroll-snap 矢印をスキップ
 * - 1.4.0: hk-grid-group — カルーセル矢印を Flickity スタイルに統一、group_cells 対応
 * - 1.3.1: hk-grid-group — カルーセル scroller 取得を直接子セレクタに限定
 * - 1.3.0: hk-grid-group — カルーセル矢印ナビ（scroll-snap 連動）
 * - 1.2.0: hk-custom:overflow-menu-hover-keep — 「さらに表示する」ホバー改善（斜め・横移動、0.3秒遅延クローズ、再ホバー、クリック切替）
 * - 1.1.0: hk-custom:header-menu-pc-gap — リサイズ後に drawer が戻らない不具合を修正（計測時は一時 menu 表示）
 * - 1.0.1: theme-custom.js → theme-custom.js.liquid に変更（Liquid 利用可）
 * - 1.0.0: hk-custom:header-menu-pc-gap — PCヘッダーメニュー間隔の自動調整
 */
(function () {
  'use strict';

  var LOG_PREFIX = '[hk-custom:header-menu-pc-gap]';
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  var THEME_RESIZE_DEBOUNCE_MS = 150;
  var OVERFLOW_LIST_READY_MAX_FRAMES = 120;
  var scheduled = false;
  var adjustingGap = false;
  var gapAdjustCooldown = false;
  var lastAppliedGapPx = null;

  window.ThemeCustom = window.ThemeCustom || {};

  /**
   * @param {HTMLElement} element
   * @param {string} lengthValue
   * @returns {number}
   */
  function resolveLengthPx(element, lengthValue) {
    if (!lengthValue) return 0;

    var probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.width = lengthValue;
    element.appendChild(probe);
    var px = probe.getBoundingClientRect().width;
    probe.remove();
    return px;
  }

  /**
   * @param {HTMLElement} menuList
   * @returns {Object} minPx / maxPx
   */
  function readGapBounds(menuList) {
    var styles = getComputedStyle(menuList);
    var minRaw = styles.getPropertyValue('--hk-menu-gap-min').trim() || 'var(--gap-xl)';
    var maxRaw = styles.getPropertyValue('--hk-menu-gap-max').trim() || 'var(--gap-2xl)';

    return {
      minPx: resolveLengthPx(menuList, minRaw),
      maxPx: resolveLengthPx(menuList, maxRaw),
    };
  }

  /**
   * @param {HTMLElement} headerComponent
   * @returns {Object | null} menuList and overflowList elements
   */
  function getHeaderMenuElements(headerComponent) {
    var menuList = headerComponent.querySelector('.header-menu .menu-list');
    var overflowList = headerComponent.querySelector('overflow-list[data-testid="header-menu-overflow-list"]');

    if (!menuList || !overflowList) return null;
    return { menuList: menuList, overflowList: overflowList };
  }

  /**
   * @param {HTMLElement} overflowList
   * @returns {boolean}
   */
  function isOverflowListReady(overflowList) {
    if (!overflowList || !overflowList.shadowRoot) return false;
    return !!overflowList.shadowRoot.querySelector('[part="list"]');
  }

  /**
   * @param {HTMLElement} overflowList
   * @param {Function} callback
   */
  function whenOverflowListReady(overflowList, callback) {
    if (isOverflowListReady(overflowList)) {
      window.requestAnimationFrame(callback);
      return;
    }

    var frames = 0;

    (function waitForReady() {
      if (isOverflowListReady(overflowList)) {
        window.requestAnimationFrame(callback);
        return;
      }

      frames += 1;
      if (frames >= OVERFLOW_LIST_READY_MAX_FRAMES) {
        if (window.console && console.warn) {
          console.warn(LOG_PREFIX, 'overflow-list not ready');
        }
        return;
      }

      window.requestAnimationFrame(waitForReady);
    })();
  }

  /**
   * @param {HTMLElement} headerComponent
   * @param {HTMLElement} menuList
   * @param {HTMLElement} overflowList
   */
  function prepareDesktopMeasurement(headerComponent, menuList, overflowList) {
    headerComponent.dataset.menuStyle = 'menu';

    if (typeof overflowList.showAll === 'function') {
      overflowList.showAll();
    }

    void headerComponent.offsetHeight;
    applyMenuGap(menuList, overflowList, Math.round(readGapBounds(menuList).minPx) || null);
    void overflowList.offsetWidth;
  }

  /**
   * overflow-list は hasOverflow=false の reflow で minimum-reached を外さない。
   * 広幅・二分探索の途中状態で属性が残ると syncMenuStyle が drawer のままになる。
   * @param {HTMLElement | null} overflowList
   */
  function clearStaleMinimumReached(overflowList) {
    if (!overflowList || !overflowList.hasAttribute('minimum-reached')) return;

    var overflowCount = parseInt(overflowList.style.getPropertyValue('--overflow-count') || '0', 10);
    if (overflowCount === 0) {
      overflowList.removeAttribute('minimum-reached');
    }
  }

  /**
   * @param {HTMLElement} overflowList
   * @param {HTMLElement} menuList
   * @param {number | null} gapPx
   * @param {boolean} [onlyReflow]
   */
  function finishDesktopMeasurement(overflowList, menuList, gapPx, onlyReflow) {
    if (overflowList.hasAttribute('disabled')) {
      overflowList.removeAttribute('disabled');
    }

    if (onlyReflow) {
      overflowList.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
      clearStaleMinimumReached(overflowList);
      return;
    }

    applyMenuGap(menuList, overflowList, gapPx);
  }

  /**
   * @param {HTMLElement} menuList
   * @param {HTMLElement} overflowList
   * @param {number | null} gapPx
   */
  function applyMenuGap(menuList, overflowList, gapPx) {
    if (gapPx && gapPx > 0) {
      menuList.style.setProperty('--menu-horizontal-gap', gapPx + 'px');
    } else {
      menuList.style.removeProperty('--menu-horizontal-gap');
    }
    overflowList.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    clearStaleMinimumReached(overflowList);
  }

  /**
   * @param {HTMLElement} overflowList
   * @returns {Object} overflowCount / minimumReached
   */
  function readMenuFitState(overflowList) {
    return {
      overflowCount: parseInt(overflowList.style.getPropertyValue('--overflow-count') || '0', 10),
      minimumReached: overflowList.hasAttribute('minimum-reached'),
    };
  }

  /**
   * @param {HTMLElement} headerComponent
   */
  function syncMenuStyle(headerComponent) {
    var overflowList = headerComponent.querySelector('overflow-list[data-testid="header-menu-overflow-list"]');
    var isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;

    if (!DESKTOP_MQ.matches) {
      headerComponent.dataset.menuStyle = 'drawer';
      return;
    }

    clearStaleMinimumReached(overflowList);

    var hasReachedMinimum = overflowList && overflowList.hasAttribute('minimum-reached');
    headerComponent.dataset.menuStyle = isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';
  }

  /**
   * @param {HTMLElement} menuList
   * @param {HTMLElement} overflowList
   * @param {number} gapPx
   * @returns {boolean}
   */
  function menuFitsAtGap(menuList, overflowList, gapPx) {
    applyMenuGap(menuList, overflowList, gapPx);
    var state = readMenuFitState(overflowList);
    return state.overflowCount === 0 && !state.minimumReached;
  }

  /**
   * @param {HTMLElement} menuList
   * @param {HTMLElement} overflowList
   * @returns {number | null}
   */
  function fitHeaderMenuGap(menuList, overflowList) {
    var bounds = readGapBounds(menuList);
    var minPx = Math.round(bounds.minPx);
    var maxPx = Math.round(bounds.maxPx);

    applyMenuGap(menuList, overflowList, minPx || null);

    if (!minPx || !maxPx || maxPx <= minPx) {
      return minPx || null;
    }

    var low = minPx;
    var high = maxPx;
    var best = minPx;

    while (low <= high) {
      var mid = Math.floor((low + high) / 2);
      if (menuFitsAtGap(menuList, overflowList, mid)) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    return best;
  }

  function runAdjustHeaderMenuGap() {
    var headerComponent = document.querySelector('#header-component');
    if (!headerComponent) return;

    var elements = getHeaderMenuElements(headerComponent);
    if (!elements) return;

    var menuList = elements.menuList;
    var overflowList = elements.overflowList;

    try {
      if (!DESKTOP_MQ.matches) {
        lastAppliedGapPx = null;
        applyMenuGap(menuList, overflowList, null);
        syncMenuStyle(headerComponent);
        return;
      }

      whenOverflowListReady(overflowList, function () {
        if (adjustingGap || gapAdjustCooldown) {
          scheduleAdjust();
          return;
        }

        adjustingGap = true;

        try {
          prepareDesktopMeasurement(headerComponent, menuList, overflowList);
          var bestGapPx = fitHeaderMenuGap(menuList, overflowList);

          if (bestGapPx === lastAppliedGapPx) {
            finishDesktopMeasurement(overflowList, menuList, bestGapPx, true);
            syncMenuStyle(headerComponent);
            return;
          }

          lastAppliedGapPx = bestGapPx;
          finishDesktopMeasurement(overflowList, menuList, bestGapPx);
          syncMenuStyle(headerComponent);
        } catch (error) {
          if (window.console && console.warn) {
            console.warn(LOG_PREFIX, error);
          }
        } finally {
          if (overflowList.hasAttribute('disabled')) {
            finishDesktopMeasurement(overflowList, menuList, lastAppliedGapPx, true);
          }
          adjustingGap = false;
          gapAdjustCooldown = true;
          window.setTimeout(function () {
            gapAdjustCooldown = false;
          }, 300);
        }
      });
    } catch (error) {
      if (window.console && console.warn) {
        console.warn(LOG_PREFIX, error);
      }
    }
  }

  function adjustHeaderMenuGap() {
    runAdjustHeaderMenuGap();
  }

  function scheduleAdjust() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        adjustHeaderMenuGap();
        window.setTimeout(function () {
          adjustHeaderMenuGap();
          scheduled = false;
        }, THEME_RESIZE_DEBOUNCE_MS);
      });
    });
  }

  function shouldDeferHeaderGapAdjust() {
    return adjustingGap || gapAdjustCooldown;
  }

  function initHeaderMenuPcGap() {
    scheduleAdjust();
    window.addEventListener('resize', scheduleAdjust, { passive: true });
    DESKTOP_MQ.addEventListener('change', scheduleAdjust);
    document.addEventListener('overflowMinimum', function () {
      if (shouldDeferHeaderGapAdjust()) return;
      scheduleAdjust();
    });

    var headerComponent = document.querySelector('#header-component');
    if (headerComponent && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        if (shouldDeferHeaderGapAdjust()) return;
        scheduleAdjust();
      }).observe(headerComponent);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleAdjust).catch(function () {});
    }
  }

  window.ThemeCustom.headerMenuPcGap = {
    init: initHeaderMenuPcGap,
    reflow: scheduleAdjust,
  };

  /* hk-custom:overflow-menu-hover-keep */
  var OVERFLOW_CLOSE_DELAY_MS = 300;
  var OVERFLOW_HOVER_BRIDGE_PX = 20;
  var OVERFLOW_INIT_MAX_RETRIES = 20;
  var overflowPanelCloseTimer;
  var defaultMenuSwitchTimer;
  var overflowLastPointer = { x: 0, y: 0 };
  var overflowPointerMoveBound = false;
  var overflowInitRetries = 0;
  var overflowCloseGuardBound = false;
  var hkOverflowAllowClose = false;
  var hkOverflowOpenSnapshot = null;
  var hkOverflowSuspendRestore = false;
  var HK_DEFAULT_MENU_ITEM_SELECTOR =
    ':scope > .menu-list__list-item:not([slot="overflow"]):not([slot="more"])';
  var HK_DEFAULT_MENU_LINK_ARIA_SELECTOR =
    '.menu-list__list-item:not([slot="overflow"]):not([slot="more"]) > .menu-list__link[aria-expanded="true"]';
  var HK_DEFAULT_MENU_SUBMENU_SELECTOR =
    '.menu-list__list-item:not([slot="overflow"]):not([slot="more"]) > .menu-list__submenu';

  /**
   * overflow-list は default slot に slot="" を付与する
   * @param {Element | null} listItem
   * @returns {string | null}
   */
  function getHeaderMenuListItemSlot(listItem) {
    if (!(listItem instanceof Element)) return null;
    if (!listItem.hasAttribute('slot')) return null;
    return listItem.getAttribute('slot') || '';
  }

  /**
   * @param {Element | null} listItem
   * @returns {boolean}
   */
  function isDefaultHeaderMenuListItem(listItem) {
    if (!(listItem instanceof Element)) return false;
    if (!listItem.closest('overflow-list')) return false;

    var slot = getHeaderMenuListItemSlot(listItem);
    return slot !== 'overflow' && slot !== 'more';
  }

  /**
   * @returns {HTMLElement | null}
   */
  function getHeaderOverflowList() {
    return document.querySelector('overflow-list[data-testid="header-menu-overflow-list"]');
  }

  /**
   * @param {HTMLElement} overflowList
   * @returns {HTMLElement | null}
   */
  function getOverflowPanel(overflowList) {
    return overflowList.shadowRoot ? overflowList.shadowRoot.querySelector('[part="overflow"]') : null;
  }

  /**
   * @param {HTMLElement} overflowList
   * @returns {HTMLElement | null}
   */
  function getOverflowListPart(overflowList) {
    return overflowList.shadowRoot ? overflowList.shadowRoot.querySelector('[part="overflow-list"]') : null;
  }

  /**
   * @returns {boolean}
   */
  function isOverflowMenuOpen() {
    var headerMenu = document.querySelector('header-menu');
    return Boolean(headerMenu && headerMenu.dataset.overflowExpanded === 'true');
  }

  /**
   * overflowExpanded 未設定でも aria-expanded でパネルが開いていることがある
   * @param {HTMLElement} [headerMenu]
   * @returns {boolean}
   */
  function isOverflowPanelShowing(headerMenu) {
    headerMenu = headerMenu || document.querySelector('header-menu');
    if (!headerMenu) return false;
    if (headerMenu.dataset.overflowExpanded === 'true') return true;
    return Boolean(headerMenu.querySelector('[slot="overflow"] .menu-list__link[aria-expanded="true"]'));
  }

  /**
   * @param {HTMLElement} headerMenu
   * @returns {boolean}
   */
  function isDefaultSlotMenuOpen(headerMenu) {
    return Boolean(headerMenu && headerMenu.querySelector(HK_DEFAULT_MENU_LINK_ARIA_SELECTOR));
  }

  /**
   * @param {HTMLElement} headerComponent
   * @returns {number}
   */
  function readHeaderVisibleHeight(headerComponent) {
    var isOverlap = headerComponent.hasAttribute('data-submenu-overlap-bottom-row');

    if (isOverlap && headerComponent.offsetHeight > 0) {
      var topRow = headerComponent.querySelector('.header__row--top');
      return topRow instanceof HTMLElement ? topRow.offsetHeight : 0;
    }

    return headerComponent.offsetHeight || 0;
  }

  /**
   * @param {HTMLElement} headerMenu
   * @param {number} finalHeight
   */
  function setHeaderSubmenuLayout(headerMenu, finalHeight) {
    var headerComponent = document.querySelector('#header-component');
    if (!headerComponent) return;

    var headerVisibleHeight = readHeaderVisibleHeight(headerComponent);
    var fullOpenHeight = finalHeight > 0 ? finalHeight + headerVisibleHeight : 0;

    headerComponent.style.setProperty('--submenu-height', finalHeight + 'px');
    headerComponent.style.setProperty('--full-open-header-height', fullOpenHeight + 'px');
    headerMenu.style.setProperty('--submenu-opacity', finalHeight > 0 ? '1' : '0');
  }

  /**
   * @param {HTMLElement} headerMenu
   * @returns {number}
   */
  function measureActiveSubmenuHeight(headerMenu) {
    var activeLink = headerMenu.querySelector('.menu-list__link[aria-expanded="true"]');
    if (!(activeLink instanceof Element)) return 0;

    var listItem = activeLink.closest('.menu-list__list-item');
    if (!(listItem instanceof Element)) return 0;

    var submenu = listItem.querySelector('.menu-list__submenu');
    var slot = listItem.getAttribute('slot');
    if (slot !== 'overflow' && submenu instanceof HTMLElement) {
      return submenu.offsetHeight || 0;
    }

    var overflowList = getHeaderOverflowList();
    var overflowPanel = overflowList ? getOverflowPanel(overflowList) : null;
    if (!overflowPanel) return submenu instanceof HTMLElement ? submenu.offsetHeight || 0 : 0;

    var overflowLinksHeight = 0;
    var slottedMenuLinks = overflowPanel.querySelector('slot')?.assignedElements() || [];
    if (slottedMenuLinks.length) {
      for (var i = 0; i < slottedMenuLinks.length; i++) {
        overflowLinksHeight += slottedMenuLinks[i].getBoundingClientRect().height;
      }
    } else {
      overflowLinksHeight = overflowPanel.offsetHeight || 0;
    }

    if (submenu instanceof HTMLElement) {
      return Math.max(overflowPanel.offsetHeight || 0, overflowLinksHeight);
    }

    return overflowLinksHeight;
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function scheduleSubmenuLayoutResync(headerMenu) {
    if (!headerMenu) return;

    function run() {
      var finalHeight = measureActiveSubmenuHeight(headerMenu);
      if (finalHeight > 0) {
        setHeaderSubmenuLayout(headerMenu, finalHeight);
      }
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(run);
    });
    window.setTimeout(run, 120);
    window.setTimeout(run, 450);
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function resetStuckOverflowExpanded(headerMenu) {
    if (headerMenu.dataset.overflowExpanded !== 'true') return;
    if (headerMenu.ariaExpanded === 'true') return;
    if (headerMenu.querySelector('[slot="overflow"] .menu-list__link[aria-expanded="true"]')) return;
    headerMenu.dataset.overflowExpanded = 'false';
  }

  /**
   * @param {Event} event
   * @returns {boolean}
   */
  function isOverflowPanelActivation(event) {
    if (!(event.target instanceof Element)) return false;
    return Boolean(event.target.closest('[slot="more"], [slot="overflow"]'));
  }

  /**
   * @param {HTMLElement} headerMenu
   * @param {Event} event
   * @returns {boolean}
   */
  function ensureOverflowExpandedState(headerMenu, event) {
    var overflowActive = headerMenu.querySelector('[slot="overflow"] .menu-list__link[aria-expanded="true"]');
    if (!isOverflowPanelActivation(event) && !overflowActive) return false;

    headerMenu.dataset.overflowExpanded = 'true';
    closeDefaultSlotSubmenus(headerMenu);
    return true;
  }

  /**
   * @param {number} x
   * @param {number} y
   * @param {DOMRect} rect
   * @returns {boolean}
   */
  function isPointInRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  /**
   * @param {Element | null} element
   * @returns {boolean}
   */
  function isDefaultHeaderMenuElement(element) {
    if (!(element instanceof Element)) return false;
    return isDefaultHeaderMenuListItem(element.closest('.menu-list__list-item'));
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function closeDefaultSlotSubmenus(headerMenu) {
    var overflowList = getHeaderOverflowList();
    if (!overflowList) return;

    var items = overflowList.querySelectorAll(HK_DEFAULT_MENU_ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('.menu-list__link');
      if (link instanceof Element) {
        link.ariaExpanded = 'false';
      }

      var submenu = items[i].querySelector('.menu-list__submenu');
      if (submenu instanceof Element) {
        delete submenu.dataset.active;
      }
    }
  }

  /**
   * @param {Event} event
   * @returns {boolean}
   */
  function isDefaultSlotMenuActivation(event) {
    if (!(event.target instanceof Element)) return false;
    return isDefaultHeaderMenuListItem(event.target.closest('.menu-list__list-item'));
  }

  /**
   * @param {Element | null | undefined} element
   * @returns {Element | null}
   */
  function getMenuActivationTarget(element) {
    if (!(element instanceof Element)) return null;
    return element.closest('.menu-list__list-item');
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function closeOverflowForMenuSwitch(headerMenu) {
    clearOverflowHoverTimers();
    clearDefaultMenuSwitchTimer();
    hkOverflowSuspendRestore = true;
    hkOverflowOpenSnapshot = null;
    resetOverflowDomState(headerMenu);
  }

  function clearDefaultMenuSwitchTimer() {
    clearTimeout(defaultMenuSwitchTimer);
    defaultMenuSwitchTimer = undefined;
  }

  /**
   * @param {HTMLElement} headerMenu
   * @param {Element} activationTarget
   */
  function scheduleDefaultMenuSwitch(headerMenu, activationTarget) {
    clearDefaultMenuSwitchTimer();
    defaultMenuSwitchTimer = window.setTimeout(function () {
      var menuActivationTarget = getMenuActivationTarget(activationTarget);
      if (!(menuActivationTarget instanceof Element)) return;

      var hovered =
        menuActivationTarget.matches(':hover') ||
        Boolean(menuActivationTarget.querySelector(':scope > [ref="menuitem"]')?.matches(':hover'));
      if (!hovered) return;

      if (isOverflowPanelShowing(headerMenu)) {
        closeOverflowForMenuSwitch(headerMenu);
      }

      if (typeof headerMenu.__hkOriginalActivate === 'function') {
        headerMenu.__hkOriginalActivate.call(headerMenu, { target: menuActivationTarget });
        scheduleSubmenuLayoutResync(headerMenu);
      }
      hkOverflowSuspendRestore = false;
    }, OVERFLOW_CLOSE_DELAY_MS);
  }

  /**
   * @param {HTMLElement} headerMenu
   * @param {Element | null} activationTarget
   */
  function activateDefaultMenuFromOverflow(headerMenu, activationTarget) {
    var menuActivationTarget = getMenuActivationTarget(activationTarget);
    if (!(menuActivationTarget instanceof Element)) return;

    clearOverflowHoverTimers();
    clearDefaultMenuSwitchTimer();

    if (isOverflowPanelShowing(headerMenu)) {
      closeOverflowForMenuSwitch(headerMenu);
    }

    if (typeof headerMenu.__hkOriginalActivate === 'function') {
      headerMenu.__hkOriginalActivate.call(headerMenu, { target: menuActivationTarget });
      scheduleSubmenuLayoutResync(headerMenu);
    }

    window.requestAnimationFrame(function () {
      hkOverflowSuspendRestore = false;
    });
  }

  /**
   * @returns {DOMRect[]}
   */
  function getOverflowInteractiveRects() {
    var overflowList = getHeaderOverflowList();
    if (!overflowList) return [];

    var rects = [];
    var selectors = [
      ':scope > .menu-list__list-item[slot="overflow"] .menu-list__link',
      ':scope > .menu-list__list-item[slot="overflow"] .menu-list__submenu',
      ':scope > .menu-list__list-item[slot="more"] .menu-list__link',
      ':scope > .menu-list__list-item[slot="more"] button',
    ];

    for (var s = 0; s < selectors.length; s++) {
      var nodes = overflowList.querySelectorAll(selectors[s]);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!(node instanceof HTMLElement)) continue;

        if (node.classList.contains('menu-list__submenu') && getComputedStyle(node).visibility === 'hidden') {
          continue;
        }

        var rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) continue;
        rects.push(rect);
      }
    }

    return rects;
  }

  /**
   * @param {DOMRect[]} rects
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerInOverflowBridge(rects, x, y) {
    if (!rects.length) return false;

    var top = rects[0].top;
    var left = rects[0].left;
    var right = rects[0].right;

    for (var i = 1; i < rects.length; i++) {
      top = Math.min(top, rects[i].top);
      left = Math.min(left, rects[i].left);
      right = Math.max(right, rects[i].right);
    }

    return (
      x >= left &&
      x <= right &&
      y >= top - OVERFLOW_HOVER_BRIDGE_PX &&
      y < top
    );
  }

  /**
   * 「さらに表示する」からドロップダウンへの斜め移動経路
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerInOverflowTravelCorridor(x, y) {
    if (!isOverflowMenuOpen()) return false;

    var overflowList = getHeaderOverflowList();
    if (!overflowList) return false;

    var more = overflowList.querySelector(
      ':scope > .menu-list__list-item[slot="more"] .menu-list__link, :scope > .menu-list__list-item[slot="more"] button'
    );
    if (!(more instanceof HTMLElement)) return false;

    var rects = getOverflowInteractiveRects();
    if (!rects.length) return false;

    var moreRect = more.getBoundingClientRect();
    var panelTop = rects[0].top;
    var panelLeft = rects[0].left;
    var panelRight = rects[0].right;
    var panelBottom = rects[0].bottom;

    for (var i = 1; i < rects.length; i++) {
      panelTop = Math.min(panelTop, rects[i].top);
      panelLeft = Math.min(panelLeft, rects[i].left);
      panelRight = Math.max(panelRight, rects[i].right);
      panelBottom = Math.max(panelBottom, rects[i].bottom);
    }

    return (
      x >= Math.min(moreRect.left, panelLeft) &&
      x <= Math.max(moreRect.right, panelRight) &&
      y >= moreRect.top &&
      y <= panelBottom
    );
  }

  /**
   * @param {number} x
   * @param {number} y
   * @returns {Element[]}
   */
  function getElementsAtPoint(x, y) {
    if (typeof document.elementsFromPoint === 'function') {
      return document.elementsFromPoint(x, y);
    }

    var target = document.elementFromPoint(x, y);
    return target ? [target] : [];
  }

  /**
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerOverOverflowTarget(x, y) {
    var nodes = getElementsAtPoint(x, y);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!(node instanceof Element)) continue;
      if (node.closest('[slot="overflow"]')) return true;
      if (node.closest('[slot="more"]')) return true;
    }

    return false;
  }

  /**
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerOverDefaultMenuTarget(x, y) {
    var nodes = getElementsAtPoint(x, y);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!(node instanceof Element)) continue;
      if (isDefaultHeaderMenuElement(node)) return true;
    }

    return false;
  }

  /**
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerInOverflowInteractionZone(x, y) {
    if (isPointerOverOverflowTarget(x, y)) return true;

    var rects = getOverflowInteractiveRects();

    for (var i = 0; i < rects.length; i++) {
      if (isPointInRect(x, y, rects[i])) return true;
    }

    if (isPointerInOverflowBridge(rects, x, y)) return true;
    if (isPointerInOverflowTravelCorridor(x, y)) return true;

    return false;
  }

  /**
   * 「さらに表示する」から overflow パネルへ移動中の通過帯。
   * 通常メニュー項目の hover に一瞬触れても overflow へ向かっている間は切替えない。
   * @param {number} x
   * @param {number} y
   * @returns {boolean}
   */
  function isPointerInOverflowTransitZone(x, y) {
    if (isPointerOverOverflowTarget(x, y)) return true;

    var rects = getOverflowInteractiveRects();
    if (isPointerInOverflowBridge(rects, x, y)) return true;
    if (isPointerInOverflowTravelCorridor(x, y)) return true;

    return false;
  }

  /**
   * @returns {boolean}
   */
  function isPointerOverOverflowMenu() {
    return isPointerInOverflowInteractionZone(overflowLastPointer.x, overflowLastPointer.y);
  }

  /**
   * @param {PointerEvent} event
   */
  function handleDocumentPointerMove(event) {
    overflowLastPointer.x = event.clientX;
    overflowLastPointer.y = event.clientY;

    if (!isOverflowMenuOpen() && !hkOverflowOpenSnapshot) return;

    if (isPointerInOverflowInteractionZone(event.clientX, event.clientY)) {
      clearOverflowHoverTimers();
      return;
    }

    scheduleOverflowCloseCheck();
  }

  function ensureOverflowPointerTracking() {
    if (overflowPointerMoveBound) return;
    document.addEventListener('pointermove', handleDocumentPointerMove, { passive: true });
    overflowPointerMoveBound = true;
  }

  function clearOverflowHoverTimers() {
    clearTimeout(overflowPanelCloseTimer);
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function captureOverflowOpenSnapshot(headerMenu) {
    var headerComponent = document.querySelector('#header-component');

    var overflowLink =
      headerMenu.querySelector('[slot="overflow"] .menu-list__link[aria-expanded="true"]') ||
      headerMenu.querySelector('[slot="overflow"] .menu-list__link');

    hkOverflowOpenSnapshot = {
      submenuHeight: headerComponent ? headerComponent.style.getPropertyValue('--submenu-height') : '',
      fullOpenHeight: headerComponent ? headerComponent.style.getPropertyValue('--full-open-header-height') : '',
      submenuOpacity: headerMenu.style.getPropertyValue('--submenu-opacity'),
      ariaExpanded: headerMenu.ariaExpanded,
      expandedLink: overflowLink instanceof Element ? overflowLink : null,
      submenuActive: overflowLink
        ? overflowLink.parentElement && overflowLink.parentElement.querySelector('.menu-list__submenu[data-active]')
        : null,
    };
  }

  /**
   * @param {HTMLElement} headerMenu
   */
  function restoreOverflowOpenSnapshot(headerMenu) {
    if (!hkOverflowOpenSnapshot) return;
    if (hkOverflowSuspendRestore) {
      hkOverflowOpenSnapshot = null;
      return;
    }
    if (isDefaultSlotMenuOpen(headerMenu)) {
      hkOverflowOpenSnapshot = null;
      return;
    }

    var headerComponent = document.querySelector('#header-component');
    headerMenu.dataset.overflowExpanded = 'true';

    if (headerComponent) {
      if (hkOverflowOpenSnapshot.submenuHeight) {
        headerComponent.style.setProperty('--submenu-height', hkOverflowOpenSnapshot.submenuHeight);
      }
      if (hkOverflowOpenSnapshot.fullOpenHeight) {
        headerComponent.style.setProperty('--full-open-header-height', hkOverflowOpenSnapshot.fullOpenHeight);
      }
    }

    if (hkOverflowOpenSnapshot.submenuOpacity) {
      headerMenu.style.setProperty('--submenu-opacity', hkOverflowOpenSnapshot.submenuOpacity);
    }

    headerMenu.ariaExpanded = hkOverflowOpenSnapshot.ariaExpanded || 'true';

    if (hkOverflowOpenSnapshot.expandedLink instanceof Element) {
      hkOverflowOpenSnapshot.expandedLink.ariaExpanded = 'true';
    }

    if (hkOverflowOpenSnapshot.submenuActive instanceof Element) {
      hkOverflowOpenSnapshot.submenuActive.dataset.active = '';
    }
  }

  function scheduleOverflowCloseCheck() {
    clearTimeout(overflowPanelCloseTimer);
    overflowPanelCloseTimer = window.setTimeout(function () {
      if (!isOverflowMenuOpen()) return;
      if (isPointerOverOverflowMenu()) {
        clearOverflowHoverTimers();
        return;
      }
      closeOverflowMenuNow();
    }, OVERFLOW_CLOSE_DELAY_MS);
  }

  /**
   * テーマの #deactivate が使えないときの DOM フォールバック
   * @param {HTMLElement} headerMenu
   */
  function resetOverflowDomState(headerMenu) {
    var expanded = headerMenu.querySelector('[aria-expanded="true"]');
    var headerComponent = document.querySelector('#header-component');

    if (headerComponent) {
      headerComponent.style.setProperty('--submenu-height', '0px');
      headerComponent.style.setProperty('--full-open-header-height', '0px');
    }

    headerMenu.style.setProperty('--submenu-opacity', '0');
    headerMenu.dataset.overflowExpanded = 'false';
    headerMenu.ariaExpanded = 'false';

    if (expanded instanceof Element) {
      expanded.ariaExpanded = 'false';
    }

    headerMenu.querySelectorAll('.menu-list__submenu[data-active]').forEach(function (submenu) {
      delete submenu.dataset.active;
    });
  }

  /**
   * テーマ内部の #state.activeItem まで含めて閉じる
   * @param {HTMLElement} headerMenu
   * @param {Element | null} [target]
   */
  function invokeThemeOverflowDeactivate(headerMenu, target) {
    if (!headerMenu.__hkOriginalDeactivate) {
      resetOverflowDomState(headerMenu);
      return;
    }

    var expanded =
      target ||
      headerMenu.querySelector('[slot="overflow"] .menu-list__link[aria-expanded="true"]') ||
      (hkOverflowOpenSnapshot && hkOverflowOpenSnapshot.expandedLink) ||
      headerMenu.querySelector('[slot="overflow"] .menu-list__link');

    if (!(expanded instanceof Element)) {
      resetOverflowDomState(headerMenu);
      return;
    }

    hkOverflowAllowClose = true;
    headerMenu.__hkOriginalDeactivate({
      target: expanded,
      relatedTarget: document.body,
      type: 'pointerleave',
      clientX: overflowLastPointer.x,
      clientY: overflowLastPointer.y,
    });
    hkOverflowAllowClose = false;
  }

  function closeOverflowMenuNow() {
    var headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    clearOverflowHoverTimers();
    clearDefaultMenuSwitchTimer();
    invokeThemeOverflowDeactivate(headerMenu);
    hkOverflowOpenSnapshot = null;
    hkOverflowSuspendRestore = false;
  }

  /**
   * テーマの #deactivate が即閉じした場合に状態を復元する
   * @param {HTMLElement} headerMenu
   */
  function installOverflowCloseGuard() {
    if (overflowCloseGuardBound) return;

    new MutationObserver(function (mutations) {
      var headerMenu = document.querySelector('header-menu');
      if (!headerMenu) return;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (!(mutation.target instanceof Element)) continue;

        if (mutation.target === headerMenu && mutation.attributeName === 'data-overflow-expanded') {
          if (hkOverflowAllowClose || hkOverflowSuspendRestore || !hkOverflowOpenSnapshot) continue;
          if (isDefaultSlotMenuOpen(headerMenu)) {
            hkOverflowOpenSnapshot = null;
            continue;
          }
          if (headerMenu.dataset.overflowExpanded !== 'false') continue;

          restoreOverflowOpenSnapshot(headerMenu);
          scheduleOverflowCloseCheck();
          continue;
        }

      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-overflow-expanded'],
      subtree: true,
    });

    var headerComponent = document.querySelector('#header-component');
    if (headerComponent) {
      new MutationObserver(function () {
        var headerMenu = document.querySelector('header-menu');
        if (!headerMenu) return;
        if (hkOverflowAllowClose || hkOverflowSuspendRestore || !hkOverflowOpenSnapshot) return;
        if (isDefaultSlotMenuOpen(headerMenu)) {
          hkOverflowOpenSnapshot = null;
          return;
        }

        var submenuHeight = headerComponent.style.getPropertyValue('--submenu-height');
        if (submenuHeight === '0px' || submenuHeight === '0') {
          restoreOverflowOpenSnapshot(headerMenu);
          scheduleOverflowCloseCheck();
        }
      }).observe(headerComponent, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    overflowCloseGuardBound = true;
  }

  /**
   * pointerleave 起因の即時クローズを止め、遅延クローズへ回す
   * @param {PointerEvent} event
   */
  function interceptOverflowPointerLeave(event) {
    var headerMenu = document.querySelector('header-menu');
    if (!isOverflowPanelShowing(headerMenu)) return;

    var related = event.relatedTarget;
    if (related instanceof Element) {
      if (related.closest('[slot="overflow"]') || related.closest('.menu-list__submenu')) return;
      if (related.closest('[slot="more"]')) return;
      if (isDefaultHeaderMenuElement(related)) {
        return;
      }
    }

    if (isPointerInOverflowInteractionZone(event.clientX, event.clientY)) return;

    event.stopImmediatePropagation();
    event.stopPropagation();
    scheduleOverflowCloseCheck();
  }

  /**
   * @param {HTMLElement} overflowList
   */
  function attachOverflowLeaveInterceptors(overflowList) {
    if (overflowList.dataset.hkLeaveInterceptors === 'true') return;

    overflowList.addEventListener('pointerleave', interceptOverflowPointerLeave, true);
    overflowList.addEventListener('pointerenter', clearOverflowHoverTimers, true);

    var items = overflowList.querySelectorAll(':scope > .menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('pointerleave', interceptOverflowPointerLeave, true);
      items[i].addEventListener('pointerenter', clearOverflowHoverTimers, true);
    }

    overflowList.dataset.hkLeaveInterceptors = 'true';
  }

  /**
   * activate はインスタンス矢印関数のため proto ではなく instance をパッチする
   * @param {HTMLElement} headerMenu
   */
  function patchHeaderMenuInstance(headerMenu) {
    if (typeof headerMenu.activate !== 'function') return;
    if (headerMenu.activate === headerMenu.__hkPatchedActivate) return;

    headerMenu.__hkOriginalActivate = headerMenu.activate;
    headerMenu.__hkOriginalDeactivate = headerMenu.deactivate.bind(headerMenu);

    var originalActivate = headerMenu.__hkOriginalActivate;
    var originalDeactivate = headerMenu.__hkOriginalDeactivate;

    var patchedActivate = function (event) {
      clearOverflowHoverTimers();
      clearDefaultMenuSwitchTimer();
      hkOverflowOpenSnapshot = null;
      hkOverflowSuspendRestore = false;

      var result = originalActivate.call(headerMenu, event);
      normalizeEmptyExpandedItem(headerMenu, event);
      scheduleSubmenuLayoutResync(headerMenu);

      return result;
    };

    var patchedDeactivate = function (event) {
      if (hkOverflowAllowClose) {
        return originalDeactivate(event);
      }

      if (event.target instanceof Element) {
        var targetItem = event.target.closest('.menu-list__list-item');
        var slot = getHeaderMenuListItemSlot(targetItem);
        if (slot === 'overflow' || slot === 'more') {
          if (isPointerInOverflowInteractionZone(event.clientX, event.clientY)) return;
          scheduleOverflowCloseCheck();
          return;
        }
      }

      return originalDeactivate(event);
    };

    headerMenu.__hkPatchedActivate = patchedActivate;
    headerMenu.__hkPatchedDeactivate = patchedDeactivate;
    headerMenu.activate = patchedActivate;
    headerMenu.deactivate = patchedDeactivate;
    headerMenu.dataset.hkInstancePatched = 'true';
  }

  /**
   * submenu を持たない項目に expanded が残ると空白パネルが出ることがある
   * @param {HTMLElement} headerMenu
   * @param {Event} event
   */
  function normalizeEmptyExpandedItem(headerMenu, event) {
    if (!(event.target instanceof Element)) return;

    var targetItem = getMenuActivationTarget(event.target);
    if (!(targetItem instanceof Element)) return;

    var targetLink = targetItem.querySelector(':scope > [ref="menuitem"]');
    if (!(targetLink instanceof Element)) return;

    var submenu = targetItem.querySelector(':scope > [ref="submenu[]"]');
    if (submenu instanceof Element) return;

    targetLink.ariaExpanded = 'false';

    headerMenu.querySelectorAll('.menu-list__submenu[data-active]').forEach(function (activeSubmenu) {
      if (activeSubmenu !== submenu) {
        delete activeSubmenu.dataset.active;
      }
    });

    if (getHeaderMenuListItemSlot(targetItem) !== 'overflow') {
      headerMenu.ariaExpanded = 'false';
      headerMenu.style.setProperty('--submenu-opacity', '0');
    }
  }

  /**
   * overflow private pointerleave を捕まえて即時 close を遅延へ差し替える
   * @param {HTMLElement} overflowList
   * @param {HTMLElement} overflowPanel
   */
  function attachOverflowLeaveInterceptors(overflowList, overflowPanel) {
    if (overflowList.dataset.hkLeaveInterceptors === 'true') return;

    function onLeave(event) {
      if (!isOverflowMenuOpen()) return;
      if (isPointerInOverflowInteractionZone(event.clientX, event.clientY)) return;

      event.stopImmediatePropagation();
      event.stopPropagation();
      scheduleOverflowCloseCheck();
    }

    function onEnter() {
      clearOverflowHoverTimers();
    }

    overflowList.addEventListener('pointerleave', onLeave, true);
    overflowList.addEventListener('pointerenter', onEnter, true);
    overflowPanel.addEventListener('pointerleave', onLeave, true);
    overflowPanel.addEventListener('pointerenter', onEnter, true);

    var listPart = getOverflowListPart(overflowList);
    if (listPart) {
      listPart.addEventListener('pointerleave', onLeave, true);
      listPart.addEventListener('pointerenter', onEnter, true);
    }

    var items = overflowList.querySelectorAll(':scope > .menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('pointerleave', onLeave, true);
      items[i].addEventListener('pointerenter', onEnter, true);
    }

    overflowList.dataset.hkLeaveInterceptors = 'true';
  }

  function bindOverflowMenuHoverKeep(headerMenu, overflowList, overflowPanel) {
    patchHeaderMenuInstance(headerMenu);

    if (overflowPanel.dataset.hkOverflowHoverKeep === 'true') {
      resetStuckOverflowExpanded(headerMenu);
      ensureOverflowPointerTracking();
      return;
    }

    overflowPanel.dataset.hkOverflowHoverKeep = 'true';
    attachOverflowLeaveInterceptors(overflowList, overflowPanel);
    resetStuckOverflowExpanded(headerMenu);
    ensureOverflowPointerTracking();
  }

  function initOverflowMenuHoverKeep() {
    if (!DESKTOP_MQ.matches) return;

    var headerMenu = document.querySelector('header-menu');
    var overflowList = getHeaderOverflowList();
    var overflowPanel = overflowList ? getOverflowPanel(overflowList) : null;

    if (!headerMenu || !overflowList || !overflowPanel) {
      if (overflowInitRetries < OVERFLOW_INIT_MAX_RETRIES) {
        overflowInitRetries += 1;
        window.setTimeout(initOverflowMenuHoverKeep, 200);
      }
      return;
    }

    bindOverflowMenuHoverKeep(headerMenu, overflowList, overflowPanel);
  }

  window.ThemeCustom.overflowMenuHoverKeep = {
    init: initOverflowMenuHoverKeep,
  };

  /**
   * hk-grid-group カルーセル矢印
   * @param {HTMLElement} [root]
   */
  function initHkGridGroupCarousels(root) {
    var scope = root || document;

    var shells = scope.querySelectorAll('.hk-grid-group-shell--arrows-mobile, .hk-grid-group-shell--arrows-desktop');

    shells.forEach(function (shell) {
      if (shell.querySelector('hk-flickity-carousel')) return;

      if (shell.dataset.hkGridCarouselInit === 'true') return;

      var scroller = shell.querySelector('.hk-grid-group > .group-block-content');
      if (!scroller) return;

      shell.dataset.hkGridCarouselInit = 'true';

      shell.querySelectorAll('.hk-grid-group__nav').forEach(function (nav) {
        var prev = nav.querySelector('[data-hk-flickity-arrow="previous"]');
        var next = nav.querySelector('[data-hk-flickity-arrow="next"]');
        if (!prev || !next) return;

        var isDesktopNav = nav.classList.contains('hk-grid-group__nav--desktop');
        var groupCells = parseInt(
          isDesktopNav ? shell.dataset.groupCellsDesktop || '1' : shell.dataset.groupCellsMobile || '1',
          10
        );
        if (groupCells < 1) groupCells = 1;

        /**
         * @param {number} direction
         */
        function scrollByPage(direction) {
          var firstItem = scroller.querySelector(':scope > *');
          if (!firstItem) return;

          var styles = window.getComputedStyle(scroller);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          var amount = (firstItem.getBoundingClientRect().width + gap) * groupCells * direction;

          scroller.scrollBy({ left: amount, behavior: 'smooth' });
        }

        prev.addEventListener('click', function () {
          scrollByPage(-1);
        });
        next.addEventListener('click', function () {
          scrollByPage(1);
        });
      });
    });
  }

  window.ThemeCustom.hkGridGroup = {
    init: initHkGridGroupCarousels,
  };

  /** @type {WeakMap<ParentNode, number[]>} */
  var popupLinkFlickityTimers = new WeakMap();

  var POPUP_NAV_SELECTOR = '[data-hk-popup-nav]';
  var POPUP_NAV_GROUP_SELECTOR = '[data-hk-popup-nav-group]';

  /**
   * @param {HTMLElement} component
   * @returns {ParentNode}
   */
  function getPopupNavScope(component) {
    var scopeMode = component.dataset.hkPopupNavScope || 'section';
    if (scopeMode === 'page') return document;

    return component.closest('.shopify-section') || document;
  }

  /**
   * @param {HTMLElement} component
   * @returns {HTMLElement[]}
   */
  function getPopupNavComponents(component) {
    var scope = getPopupNavScope(component);

    return Array.from(scope.querySelectorAll('dialog-component.popup-link')).filter(function (node) {
      return node instanceof HTMLElement && node.querySelector('dialog.popup-link__content');
    });
  }

  /**
   * @param {HTMLDialogElement} dialog
   */
  function syncPopupLinkModalNav(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return;

    var component = dialog.closest('dialog-component.popup-link');
    if (!(component instanceof HTMLElement)) return;
    if (component.dataset.hkPopupNavEnabled !== 'true') return;

    var components = getPopupNavComponents(component);
    var index = components.indexOf(component);
    var hasNav = components.length > 1;
    var hasPrev = hasNav && index > 0;
    var hasNext = hasNav && index >= 0 && index < components.length - 1;

    dialog.querySelectorAll(POPUP_NAV_SELECTOR + '[data-hk-popup-nav="prev"]').forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      node.hidden = !hasPrev;
      if (node instanceof HTMLButtonElement) node.disabled = !hasPrev;
    });

    dialog.querySelectorAll(POPUP_NAV_SELECTOR + '[data-hk-popup-nav="next"]').forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      node.hidden = !hasNext;
      if (node instanceof HTMLButtonElement) node.disabled = !hasNext;
    });

    dialog.querySelectorAll(POPUP_NAV_GROUP_SELECTOR).forEach(function (group) {
      if (!(group instanceof HTMLElement)) return;

      var prevBtn = group.querySelector(POPUP_NAV_SELECTOR + '[data-hk-popup-nav="prev"]');
      var nextBtn = group.querySelector(POPUP_NAV_SELECTOR + '[data-hk-popup-nav="next"]');
      var prevHidden = prevBtn instanceof HTMLElement ? prevBtn.hidden : true;
      var nextHidden = nextBtn instanceof HTMLElement ? nextBtn.hidden : true;
      group.hidden = prevHidden && nextHidden;
    });
  }

  /**
   * @param {HTMLElement} targetComponent
   */
  function switchPopupLinkDialog(targetComponent) {
    if (!(targetComponent instanceof HTMLElement)) return;
    if (typeof targetComponent.showDialog !== 'function') return;

    var openDialog = document.querySelector('dialog.popup-link__content[open]');
    var currentComponent =
      openDialog instanceof HTMLDialogElement ? openDialog.closest('dialog-component.popup-link') : null;

    if (currentComponent === targetComponent && openDialog instanceof HTMLDialogElement) {
      syncPopupLinkModalNav(openDialog);
      return;
    }

    var openPromise = Promise.resolve();

    if (currentComponent instanceof HTMLElement && currentComponent !== targetComponent) {
      if (typeof currentComponent.closeDialog === 'function') {
        openPromise = currentComponent.closeDialog();
      }
    }

    Promise.resolve(openPromise).then(function () {
      if (typeof targetComponent.showDialog === 'function') {
        targetComponent.showDialog();
      }
    });
  }

  /**
   * @param {Event} event
   */
  function onPopupLinkModalNavClick(event) {
    if (!(event.target instanceof Element)) return;

    var nav = event.target.closest(POPUP_NAV_SELECTOR);
    if (!(nav instanceof HTMLElement)) return;

    var dialog = nav.closest('dialog.popup-link__content');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    var component = dialog.closest('dialog-component.popup-link');
    if (!(component instanceof HTMLElement)) return;

    var components = getPopupNavComponents(component);
    var index = components.indexOf(component);
    if (index < 0) return;

    var action = nav.dataset.hkPopupNav;
    var targetComponent = null;

    if (action === 'prev' && index > 0) {
      targetComponent = components[index - 1];
    } else if (action === 'next' && index < components.length - 1) {
      targetComponent = components[index + 1];
    }

    if (!(targetComponent instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    switchPopupLinkDialog(targetComponent);
  }

  /**
   * @param {KeyboardEvent} event
   */
  function onPopupLinkModalNavKeyDown(event) {
    var openDialog = document.querySelector('dialog.popup-link__content[open]');
    if (!(openDialog instanceof HTMLDialogElement)) return;

    var component = openDialog.closest('dialog-component.popup-link');
    if (!(component instanceof HTMLElement)) return;
    if (component.dataset.hkPopupNavEnabled !== 'true') return;

    var target = event.target;
    if (
      target instanceof HTMLElement &&
      target.closest('input, textarea, select, [contenteditable="true"]')
    ) {
      return;
    }

    var components = getPopupNavComponents(component);
    var index = components.indexOf(component);
    if (index < 0) return;

    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      switchPopupLinkDialog(components[index - 1]);
    } else if (event.key === 'ArrowRight' && index < components.length - 1) {
      event.preventDefault();
      switchPopupLinkDialog(components[index + 1]);
    }
  }

  document.addEventListener('click', onPopupLinkModalNavClick);
  document.addEventListener('keydown', onPopupLinkModalNavKeyDown);

  /**
   * popup-link モーダル内 hk-grid-group カルーセル
   * 閉じた dialog は高さ 0 で init される → 開放後に1回だけ reinit。遅延は syncLayout のみ。
   *
   * @param {ParentNode} root
   */
  function initPopupLinkFlickityCarousels(root) {
    if (!root || !root.querySelector('hk-flickity-carousel')) return;

    var pending = popupLinkFlickityTimers.get(root);
    if (pending) {
      pending.forEach(function (id) {
        window.clearTimeout(id);
      });
    }

    function syncPopupChrome() {
      if (window.HkFlickity && typeof window.HkFlickity.syncChrome === 'function') {
        window.HkFlickity.syncChrome(root);
      }
    }

    function syncPopupLayout() {
      if (window.HkFlickity && typeof window.HkFlickity.syncLayout === 'function') {
        window.HkFlickity.syncLayout(root);
      }
    }

    function initCarousels() {
      root.querySelectorAll('hk-flickity-carousel').forEach(function (carousel) {
        if (window.HkFlickity && typeof window.HkFlickity.initWhenVisible === 'function') {
          window.HkFlickity.initWhenVisible(carousel);
        }
      });
    }

    function finishOpen() {
      initCarousels();
      syncPopupChrome();
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(finishOpen);
    });

    var timerIds = [
      window.setTimeout(function () {
        syncPopupLayout();
        syncPopupChrome();
      }, 300),
    ];
    popupLinkFlickityTimers.set(root, timerIds);
  }

  /**
   * @param {Event} event
   */
  function onPopupLinkDialogOpen(event) {
    var target = event.target;
    var dialog =
      target instanceof HTMLDialogElement
        ? target
        : target instanceof HTMLElement
          ? target.querySelector('dialog.popup-link__content, dialog')
          : null;

    if (!(dialog instanceof HTMLDialogElement)) return;
    if (!dialog.classList.contains('popup-link__content')) return;

    var inner = dialog.querySelector('.popup-link__inner');
    if (!inner) return;

    initPopupLinkFlickityCarousels(inner);
    syncPopupLinkModalNav(dialog);
  }

  function bindPopupLinkDialogOpenListeners(root) {
    var scope = root || document;
    scope.querySelectorAll('dialog-component.popup-link').forEach(function (dialogComponent) {
      if (!(dialogComponent instanceof HTMLElement)) return;
      if (dialogComponent.dataset.hkPopupDialogBound === 'true') return;

      var dialog = dialogComponent.querySelector('dialog.popup-link__content');
      if (!dialog) return;

      dialogComponent.dataset.hkPopupDialogBound = 'true';
      dialogComponent.addEventListener('dialog:open', onPopupLinkDialogOpen);
    });
  }

  bindPopupLinkDialogOpenListeners(document);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target instanceof HTMLElement) {
      bindPopupLinkDialogOpenListeners(event.target);
    }
  });

  /**
   * アップロード SVG をインライン化し fill/stroke を currentColor に置換
   * @param {ParentNode} [root]
   */
  function initHkButtonSvgRecolor(root) {
    var scope = root || document;
    var images = scope.querySelectorAll('img[data-hk-svg-recolor]:not([data-hk-svg-recolor-done])');

    images.forEach(function (img) {
      var src = img.currentSrc || img.src;
      if (!src || !/\.svg([?#]|$)/i.test(src)) return;

      img.dataset.hkSvgRecolorDone = 'pending';

      fetch(src)
        .then(function (response) {
          if (!response.ok) throw new Error('SVG fetch failed');
          return response.text();
        })
        .then(function (svgText) {
          var doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
          var svg = doc.querySelector('svg');
          if (!svg) throw new Error('SVG parse failed');

          svg.classList.add('hk-button__icon-media', 'hk-button__icon-svg-inline');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');

          if (img.style.width) svg.style.width = img.style.width;
          if (img.style.height) svg.style.height = img.style.height;

          svg.querySelectorAll('[fill]').forEach(function (node) {
            if (node.getAttribute('fill') !== 'none') {
              node.setAttribute('fill', 'currentColor');
            }
          });

          svg.querySelectorAll('[stroke]').forEach(function (node) {
            if (node.getAttribute('stroke') !== 'none') {
              node.setAttribute('stroke', 'currentColor');
            }
          });

          if (!svg.getAttribute('fill')) {
            svg.setAttribute('fill', 'currentColor');
          }

          img.replaceWith(svg);
        })
        .catch(function () {
          img.dataset.hkSvgRecolorDone = 'failed';
        });
    });
  }

  window.ThemeCustom.hkButtonSvgRecolor = {
    init: initHkButtonSvgRecolor,
  };

  /**
   * 表示中タブパネル内の Flickity を再初期化（非表示中 init による 0 幅を解消）
   *
   * @param {HTMLElement[]} panels
   * @param {number} [attempt]
   */
  function refreshFlickityInTabPanels(panels, attempt) {
    if (!panels || panels.length === 0) return;

    var tryCount = typeof attempt === 'number' ? attempt : 0;

    function runRefresh() {
      if (
        !window.HkFlickity ||
        typeof window.HkFlickity.initWhenVisible !== 'function'
      ) {
        if (tryCount < 20) {
          window.setTimeout(function () {
            refreshFlickityInTabPanels(panels, tryCount + 1);
          }, 50);
        }
        return;
      }

      panels.forEach(function (panel) {
        if (!(panel instanceof HTMLElement) || panel.hidden) return;
        window.HkFlickity.initWhenVisible(panel);
        initHkGridGroupCarousels(panel);
      });
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(runRefresh);
    });
  }

  /**
   * hk-category-tabs — タブ名|ターゲットクラス → 同一セクション内 .hk-tab-target 表示切替
   *
   * @param {ParentNode} [scope]
   */
  function initHkCategoryTabs(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var tabRoots = root.querySelectorAll('[data-hk-category-tabs]');

    tabRoots.forEach(function (tabRoot) {
      if (!(tabRoot instanceof HTMLElement)) return;

      var paramName = tabRoot.dataset.queryParam || 'tab';
      var sectionScope = tabRoot.closest('.shopify-section') || tabRoot.parentElement || document;
      var tabs = tabRoot.querySelectorAll('.hk-category-tabs__tab[role="tab"]');

      var defaultTarget = (tabRoot.dataset.defaultTarget || '').trim();
      if (!defaultTarget && tabs.length > 0 && tabs[0] instanceof HTMLElement) {
        defaultTarget = (tabs[0].dataset.targetClass || '').trim();
      }

      /** @returns {NodeListOf<Element>} */
      function getAllTabPanels() {
        return sectionScope.querySelectorAll('.hk-tab-target');
      }

      /**
       * @param {string} className
       * @returns {HTMLElement[]}
       */
      function getPanelsByTargetClass(className) {
        var value = className.trim();
        if (!value) return [];
        var nodes = sectionScope.querySelectorAll('.hk-tab-target.' + CSS.escape(value));
        return Array.prototype.slice.call(nodes);
      }

      /** @returns {HTMLElement[]} */
      function getActivePanels() {
        var active = [];
        Array.prototype.forEach.call(getAllTabPanels(), function (panel) {
          if (!(panel instanceof HTMLElement)) return;
          if (panel.classList.contains('hk-tab-target--active') && !panel.hidden) {
            active.push(panel);
          }
        });
        return active;
      }

      /**
       * @param {HTMLElement[]} panelsA
       * @param {HTMLElement[]} panelsB
       * @returns {boolean}
       */
      function panelsShareAny(panelsA, panelsB) {
        return panelsA.some(function (panel) {
          return panelsB.indexOf(panel) !== -1;
        });
      }

      /** @returns  */
      function getTabAnimConfig() {
        var type = (tabRoot.dataset.contentAnimation || 'none').trim();
        var durationMs = parseInt(tabRoot.dataset.animationDuration || '300', 10);
        if (isNaN(durationMs) || durationMs < 0) durationMs = 300;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          type = 'none';
        }
        return {
          type: type,
          modClass: type.replace(/_/g, '-'),
          durationMs: durationMs,
        };
      }

      /** @param {string} activeTarget */
      function updateTabButtons(activeTarget) {
        tabs.forEach(function (tab) {
          if (!(tab instanceof HTMLElement)) return;
          var tabTarget = (tab.dataset.targetClass || '').trim();
          var isActive = tabTarget === activeTarget;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          tab.classList.toggle('hk-category-tabs__tab--active', isActive);
        });
      }

      /**
       * @param {string} activeTarget
       * @returns {boolean}
       */
      function tabButtonsMatchTarget(activeTarget) {
        var matched = false;
        tabs.forEach(function (tab) {
          if (!(tab instanceof HTMLElement)) return;
          if ((tab.dataset.targetClass || '').trim() === activeTarget) matched = true;
        });
        return matched;
      }

      /**
       * @param {string} activeTarget
       * @returns {HTMLElement[]}
       */
      function applyPanelsInstant(activeTarget) {
        var targetClass = activeTarget.trim();
        var visiblePanels = [];
        Array.prototype.forEach.call(getAllTabPanels(), function (node) {
          if (!(node instanceof HTMLElement)) return;
          var show = node.classList.contains(targetClass);
          node.hidden = !show;
          node.classList.toggle('hk-tab-target--active', show);
          node.classList.remove(
            'hk-tab-target--leaving',
            'hk-tab-target--entering',
            'hk-tab-target--entering-active'
          );
          node.classList.remove(
            'hk-tab-target--anim-fade',
            'hk-tab-target--anim-slide-up',
            'hk-tab-target--anim-slide-down'
          );
          node.style.removeProperty('--hk-cat-tab-anim-duration');
          if (show) visiblePanels.push(node);
        });
        return visiblePanels;
      }

      /** @param {HTMLElement[]} visiblePanels */
      function finishTabPanelSwitch(visiblePanels) {
        tabRoot.classList.add('hk-category-tabs--initialized');
        refreshFlickityInTabPanels(visiblePanels);
        window.setTimeout(function () {
          refreshFlickityInTabPanels(visiblePanels);
        }, 100);
        window.setTimeout(function () {
          refreshFlickityInTabPanels(visiblePanels);
        }, 300);
        document.dispatchEvent(
          new CustomEvent('hk-category-tabs:ready', {
            bubbles: true,
            detail: { panels: visiblePanels, tabRoot: tabRoot },
          })
        );
      }

      /** @param {HTMLElement} node @param {string} modClass */
      function clearPanelAnimState(node, modClass) {
        node.classList.remove(
          'hk-tab-target--leaving',
          'hk-tab-target--entering',
          'hk-tab-target--entering-active',
          'hk-tab-target--anim-' + modClass
        );
        node.style.removeProperty('--hk-cat-tab-anim-duration');
      }

      /**
       * @param {string} targetClass
       * @param  [options]
       */
      function applyTarget(targetClass, options) {
        var activeTarget = targetClass.trim();
        var animate = !!(options && options.animate);
        var config = getTabAnimConfig();
        var matched = tabButtonsMatchTarget(activeTarget);

        updateTabButtons(activeTarget);

        if (!matched && defaultTarget) {
          applyTarget(defaultTarget, options);
          return;
        }

        if (!animate || config.type === 'none') {
          var instantVisiblePanels = applyPanelsInstant(activeTarget);
          tabRoot.dataset.hkCategoryTabsAnimating = 'false';
          finishTabPanelSwitch(instantVisiblePanels);
          return;
        }

        var incomingPanels = getPanelsByTargetClass(activeTarget);
        var outgoingPanels = getActivePanels().filter(function (panel) {
          return incomingPanels.indexOf(panel) === -1;
        });

        if (incomingPanels.length === 0) {
          finishTabPanelSwitch(applyPanelsInstant(activeTarget));
          return;
        }

        if (panelsShareAny(incomingPanels, outgoingPanels)) {
          finishTabPanelSwitch(applyPanelsInstant(activeTarget));
          return;
        }

        tabRoot.dataset.hkCategoryTabsAnimating = 'true';
        var modClass = config.modClass;
        var durationMs = config.durationMs;
        var animClass = 'hk-tab-target--anim-' + modClass;

        /** @param {string} shownTarget */
        function finalizePanels(shownTarget) {
          var visiblePanels = applyPanelsInstant(shownTarget);
          tabRoot.dataset.hkCategoryTabsAnimating = 'false';
          finishTabPanelSwitch(visiblePanels);
        }

        /** @param {HTMLElement[]} panels */
        function revealPanels(panels) {
          panels.forEach(function (panel) {
            panel.hidden = false;
            panel.style.setProperty('--hk-cat-tab-anim-duration', durationMs + 'ms');
            panel.classList.add('hk-tab-target--active', animClass, 'hk-tab-target--entering');
          });
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              panels.forEach(function (panel) {
                panel.classList.add('hk-tab-target--entering-active');
              });
            });
          });
          window.setTimeout(function () {
            panels.forEach(function (panel) {
              clearPanelAnimState(panel, modClass);
            });
          }, durationMs);
        }

        /** @param {HTMLElement[]} panels @param {function(): void} done */
        function leavePanels(panels, done) {
          panels.forEach(function (panel) {
            panel.style.setProperty('--hk-cat-tab-anim-duration', durationMs + 'ms');
            panel.classList.add(animClass, 'hk-tab-target--leaving');
            panel.classList.remove('hk-tab-target--active');
          });
          window.setTimeout(function () {
            panels.forEach(function (panel) {
              panel.hidden = true;
              clearPanelAnimState(panel, modClass);
            });
            done();
          }, durationMs);
        }

        if (outgoingPanels.length === 0) {
          revealPanels(incomingPanels);
          window.setTimeout(function () {
            finalizePanels(activeTarget);
          }, durationMs);
          return;
        }

        leavePanels(outgoingPanels, function () {
          revealPanels(incomingPanels);
          window.setTimeout(function () {
            finalizePanels(activeTarget);
          }, durationMs);
        });
      }

      /** @param {string} targetClass @param {boolean} [pushHistory] @param {boolean} [animate] */
      function setTarget(targetClass, pushHistory, animate) {
        var value = targetClass.trim();
        if (!value) return;
        if (tabRoot.dataset.hkCategoryTabsAnimating === 'true') return;

        var url = new URL(window.location.href);
        url.searchParams.set(paramName, value);

        if (pushHistory) {
          window.history.pushState({ hkCategoryTabTarget: value }, '', url);
        } else {
          window.history.replaceState({ hkCategoryTabTarget: value }, '', url);
        }

        applyTarget(value, { animate: animate === true });
      }

      function syncFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var current = params.get(paramName);
        if (!current) {
          if (defaultTarget) setTarget(defaultTarget, false, false);
          return;
        }
        applyTarget(current, { animate: false });
      }

      if (tabRoot.dataset.hkCategoryTabsBound === 'true') {
        syncFromUrl();
        return;
      }
      tabRoot.dataset.hkCategoryTabsBound = 'true';

      tabs.forEach(function (tab) {
        if (!(tab instanceof HTMLElement)) return;
        tab.addEventListener('click', function () {
          setTarget(tab.dataset.targetClass || defaultTarget, true, true);
        });
        tab.addEventListener('keydown', function (event) {
          if (!(event instanceof KeyboardEvent)) return;
          var index = Array.prototype.indexOf.call(tabs, tab);
          var nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          var nextTab = tabs[nextIndex];
          if (nextTab instanceof HTMLElement) {
            nextTab.focus();
            setTarget(nextTab.dataset.targetClass || defaultTarget, true, true);
          }
        });
      });

      syncFromUrl();
    });
  }

  if (!window.__hkCategoryTabsPopstateBound) {
    window.__hkCategoryTabsPopstateBound = true;
    window.addEventListener('popstate', function () {
      initHkCategoryTabs(document);
    });
  }

  window.ThemeCustom.hkCategoryTabs = {
    init: initHkCategoryTabs,
  };

  /**
   * hk-mo-cards — URL クエリでカード表示を安定フィルタ
   *
   * @param {ParentNode} [scope]
   */
  function initHkMoCardsQueryFilter(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var lists = root.querySelectorAll('.hk-mo-cards[data-hk-query-filter-param]');

    lists.forEach(function (list) {
      if (!(list instanceof HTMLElement)) return;

      var paramName = list.dataset.hkQueryFilterParam;
      if (!paramName) {
        list.classList.remove('hk-mo-cards--query-filter-pending');
        return;
      }

      var target = new URLSearchParams(window.location.search).get(paramName);
      var cards = list.querySelectorAll('.hk-mo-cards__card, .card.hk-mo-carousel-card[data-carousel-card]');
      var visibleCount = 0;

      if (!target) {
        cards.forEach(function (card) {
          if (card instanceof HTMLElement) card.hidden = false;
        });
        list.classList.remove('hk-mo-cards--query-filter-pending');
        var emptyNoParam = list.querySelector('.hk-mo-cards__empty--filter');
        if (emptyNoParam instanceof HTMLElement) emptyNoParam.hidden = true;
        return;
      }

      var targetNorm = target.trim().toLowerCase();

      cards.forEach(function (card) {
        if (!(card instanceof HTMLElement)) return;

        var raw = card.getAttribute('data-hk-mo-filter-value') || '';
        var values = raw
          .split(',')
          .map(function (value) {
            return value.trim().toLowerCase();
          })
          .filter(Boolean);
        var match = values.indexOf(targetNorm) !== -1;
        card.hidden = !match;
        if (match) visibleCount += 1;
      });

      list.classList.remove('hk-mo-cards--query-filter-pending');

      var emptyEl = list.querySelector('.hk-mo-cards__empty--filter');
      if (emptyEl instanceof HTMLElement) {
        emptyEl.hidden = visibleCount > 0;
      }

      var flickityHost = list.closest('hk-flickity-carousel');
      if (flickityHost && window.HkFlickity && typeof window.HkFlickity.init === 'function') {
        window.HkFlickity.init(flickityHost);
      }
    });
  }

  window.ThemeCustom.hkMoCardsQueryFilter = {
    init: initHkMoCardsQueryFilter,
  };

  /**
   * @param {string} prefix
   * @param {string} anchorId
   * @returns {string}
   */
  function hkMoHandleFromAnchorId(prefix, anchorId) {
    var normalizedPrefix = (prefix || '').trim().toLowerCase();
    if (!normalizedPrefix || !anchorId) return '';

    var needle = normalizedPrefix + '-';
    var normalizedId = anchorId.trim().toLowerCase();
    if (normalizedId.indexOf(needle) !== 0) return '';

    return anchorId.trim().slice(needle.length);
  }

  /**
   * @param {HTMLElement} card
   */
  function hkMoClearCardActive(card) {
    card.classList.remove('hk-mo-card--active');
    Array.prototype.forEach.call(card.classList, function (cls) {
      if (cls.indexOf('color-') === 0) card.classList.remove(cls);
    });
  }

  /**
   * @param {HTMLElement} card
   * @param {string} scheme
   */
  function hkMoApplyCardActive(card, scheme) {
    hkMoClearCardActive(card);
    card.classList.add('hk-mo-card--active', 'color-' + (scheme || 'scheme-2'));
  }

  /**
   * @param {string} prefix
   * @param {string} anchorId
   * @returns {HTMLElement | null}
   */
  function hkMoFindAnchorTargetCard(prefix, anchorId) {
    if (!anchorId) return null;

    var byId = document.getElementById(anchorId);
    if (byId instanceof HTMLElement) return byId;

    var byData = null;
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      byData = document.querySelector('[data-hk-mo-anchor-id="' + CSS.escape(anchorId) + '"]');
    } else {
      byData = document.querySelector('[data-hk-mo-anchor-id="' + anchorId.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
    }
    if (byData instanceof HTMLElement) return byData;

    var handle = hkMoHandleFromAnchorId(prefix, anchorId);
    if (!handle) return null;
    var handleNorm = handle.toLowerCase();

    var fallback = null;
    document.querySelectorAll('.hk-mo-cards__card[data-hk-mo-handle]').forEach(function (card) {
      if (!(card instanceof HTMLElement)) return;
      var cardHandle = (card.getAttribute('data-hk-mo-handle') || '').trim().toLowerCase();
      if (cardHandle !== handleNorm) return;
      if (card.id) {
        fallback = card;
        return;
      }
      if (!fallback && card.closest('hk-flickity-carousel')) {
        fallback = card;
      }
    });

    return fallback;
  }

  /**
   * @param {HTMLElement} targetEl
   */
  function hkMoRestorePageScroll(savedX, savedY) {
    window.scrollTo({ left: savedX, top: savedY, behavior: 'instant' });
    window.requestAnimationFrame(function () {
      window.scrollTo({ left: savedX, top: savedY, behavior: 'instant' });
    });
  }

  /**
   * アンカー着地点の上余白（--header-height + scroll-margin、CSS と揃える）
   *
   * @param {HTMLElement} marginSource
   * @returns {number}
   */
  function hkMoGetAnchorScrollOffset(marginSource) {
    if (marginSource instanceof HTMLElement) {
      var scrollMargin = parseFloat(window.getComputedStyle(marginSource).scrollMarginTop);
      if (!isNaN(scrollMargin) && scrollMargin > 0) {
        return scrollMargin;
      }
    }

    var headerHeight = parseFloat(
      window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    if (isNaN(headerHeight)) headerHeight = 0;

    return headerHeight + 24;
  }

  /**
   * @param {HTMLElement} scrollTarget
   * @param {HTMLElement} marginSource
   */
  function hkMoScrollElementIntoView(scrollTarget, marginSource) {
    if (!(scrollTarget instanceof HTMLElement)) return;

    var offset = hkMoGetAnchorScrollOffset(marginSource);
    var top = window.scrollY + scrollTarget.getBoundingClientRect().top - offset;

    window.scrollTo({
      top: Math.max(0, top),
      left: window.scrollX,
      behavior: 'smooth',
    });
  }

  /**
   * hk-grid-group 内カルーセルが現 BP で有効か（PC グリッド / SP カルーセル切替）
   *
   * @param {HTMLElement} carousel
   * @returns {boolean}
   */
  function hkMoIsCarouselModeActive(carousel) {
    if (!(carousel instanceof HTMLElement)) return false;

    var mode = DESKTOP_MQ.matches
      ? carousel.dataset.layoutModeDesktop || 'carousel'
      : carousel.dataset.layoutModeMobile || 'carousel';

    return mode === 'carousel';
  }

  /**
   * @param {string} prefix
   * @param {string} anchorId
   */
  function hkMoScrollToAnchorTarget(prefix, anchorId) {
    var anchorEl = hkMoFindAnchorTargetCard(prefix, anchorId);
    if (!(anchorEl instanceof HTMLElement)) return;

    var carousel = anchorEl.closest('hk-flickity-carousel');
    var scrollTarget = anchorEl;

    if (carousel instanceof HTMLElement && hkMoIsCarouselModeActive(carousel)) {
      scrollTarget = carousel.closest('.hk-flickity-carousel-shell') || carousel;
    }

    hkMoScrollElementIntoView(scrollTarget, anchorEl);
  }

  /**
   * @param {HTMLElement} targetEl
   */
  function hkMoSelectFlickityForCard(targetEl) {
    if (!(targetEl instanceof HTMLElement)) return;

    var carousel = targetEl.closest('hk-flickity-carousel');
    if (!(carousel instanceof HTMLElement)) return;
    if (!hkMoIsCarouselModeActive(carousel)) return;

    /** @param {number} attempt */
    var trySelect = function (attempt) {
      var track = carousel.querySelector('.hk-flickity-carousel__track');
      if (!track || typeof window.Flickity !== 'function') {
        if (attempt < 20) {
          window.setTimeout(function () {
            trySelect(attempt + 1);
          }, 50);
        }
        return;
      }

      if (typeof carousel.engageUserNavigation === 'function') {
        carousel.engageUserNavigation();
      }

      var flkty = window.Flickity.data(track);
      if (!flkty) {
        if (window.HkFlickity && typeof window.HkFlickity.initWhenVisible === 'function') {
          window.HkFlickity.initWhenVisible(carousel);
        }
        if (attempt < 20) {
          window.setTimeout(function () {
            trySelect(attempt + 1);
          }, 50);
        }
        return;
      }

      var cell =
        targetEl.closest('.hk-flickity-cell') ||
        (targetEl.classList.contains('group-block') ? targetEl : null) ||
        (targetEl.classList.contains('hk-mo-cards__card') ? targetEl : null) ||
        targetEl;

      if (!(cell instanceof HTMLElement)) return;

      var savedX = window.scrollX;
      var savedY = window.scrollY;

      if (typeof flkty.selectCell === 'function') {
        flkty.selectCell(cell, true, true);
      } else {
        var hit = flkty.getCell ? flkty.getCell(cell) : null;
        if (hit && typeof flkty.select === 'function') {
          var idx = flkty.getCellSlideIndex ? flkty.getCellSlideIndex(hit) : -1;
          if (idx >= 0) flkty.select(idx, true, true);
        }
      }

      if (typeof flkty.reposition === 'function') {
        flkty.reposition();
      }
      if (typeof flkty.resize === 'function') {
        flkty.resize();
      }

      hkMoRestorePageScroll(savedX, savedY);
    };

    trySelect(0);
  }

  /**
   * @param {string} [anchorId]
   */
  function syncHkMoAnchorNav(anchorId) {
    var raw = anchorId;
    if (raw == null) {
      raw = window.location.hash ? window.location.hash.slice(1) : '';
    }
    if (!raw) return;

    var decoded = raw;
    try {
      decoded = decodeURIComponent(raw);
    } catch (e) {
      decoded = raw;
    }

    var matchedPrefix = '';
    document.querySelectorAll('[data-hk-mo-anchor-prefix]').forEach(function (list) {
      if (!(list instanceof HTMLElement)) return;
      var listPrefix = (list.dataset.hkMoAnchorPrefix || '').trim();
      if (!listPrefix) return;
      if (hkMoHandleFromAnchorId(listPrefix, decoded)) matchedPrefix = listPrefix;
    });

    if (!matchedPrefix) return;

    var handle = hkMoHandleFromAnchorId(matchedPrefix, decoded);
    if (!handle) return;

    var handleNorm = handle.toLowerCase();

    document.querySelectorAll('[data-hk-mo-anchor-prefix="' + matchedPrefix + '"]').forEach(function (list) {
      if (!(list instanceof HTMLElement)) return;

      if (list.dataset.hkMoAnchorHighlight === 'true') {
        var scheme = list.dataset.hkMoActiveScheme || 'scheme-2';
        list.querySelectorAll('.hk-mo-cards__card').forEach(function (card) {
          if (card instanceof HTMLElement) hkMoClearCardActive(card);
        });
        list.querySelectorAll('.hk-mo-cards__card').forEach(function (card) {
          if (!(card instanceof HTMLElement)) return;
          var cardHandle = (card.getAttribute('data-hk-mo-handle') || '').trim().toLowerCase();
          if (cardHandle === handleNorm) hkMoApplyCardActive(card, scheme);
        });
      }
    });

    var targetCard = hkMoFindAnchorTargetCard(matchedPrefix, decoded);
    if (targetCard) {
      hkMoSelectFlickityForCard(targetCard);
      window.requestAnimationFrame(function () {
        hkMoScrollToAnchorTarget(matchedPrefix, decoded);
      });
      window.setTimeout(function () {
        hkMoScrollToAnchorTarget(matchedPrefix, decoded);
      }, 200);
    }
  }

  /**
   * composable MO 一覧 — 接頭辞付きアンカー連携
   *
   * @param {ParentNode} [scope]
   */
  function initHkMoAnchorNav(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (!root.querySelector('[data-hk-mo-anchor-prefix]')) return;

    syncHkMoAnchorNav();

    if (initHkMoAnchorNav.bound) return;
    initHkMoAnchorNav.bound = true;

    window.addEventListener('hashchange', function () {
      syncHkMoAnchorNav();
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!(event.target instanceof Element)) return;
        var link = event.target.closest('a[data-hk-mo-anchor-link], a.hk-mo-card__link[href^="#"]');
        if (!(link instanceof HTMLAnchorElement)) return;

        var href = (link.getAttribute('href') || '').trim();
        if (!href || href.charAt(0) !== '#') return;

        var id = href.slice(1);
        if (!id) return;

        event.preventDefault();

        if (window.history && typeof window.history.pushState === 'function') {
          window.history.pushState(null, '', '#' + id);
        } else {
          window.location.hash = id;
        }

        syncHkMoAnchorNav(id);
      },
      true
    );
  }

  window.ThemeCustom.hkMoAnchorNav = {
    init: initHkMoAnchorNav,
    sync: syncHkMoAnchorNav,
  };

  function observeHeaderMenuReconnect() {
    if (observeHeaderMenuReconnect.bound) return;
    observeHeaderMenuReconnect.bound = true;

    new MutationObserver(function () {
      var headerMenu = document.querySelector('header-menu');
      if (!headerMenu) return;
      if (headerMenu.activate === headerMenu.__hkPatchedActivate) return;
      initOverflowMenuHoverKeep();
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function initThemeCustom() {
    initHeaderMenuPcGap();
    initOverflowMenuHoverKeep();
    observeHeaderMenuReconnect();
    window.setTimeout(initOverflowMenuHoverKeep, 800);
    initHkCategoryTabs();
    initHkGridGroupCarousels();
    initHkButtonSvgRecolor();
    initHkMoCardsQueryFilter();
    initHkMoAnchorNav();
  }

  DESKTOP_MQ.addEventListener('change', initOverflowMenuHoverKeep);

  document.addEventListener('shopify:section:load', function (event) {
    var target = /** @type {HTMLElement} */ (event.target);
    initHkGridGroupCarousels(target);
    initHkButtonSvgRecolor(target);
    initHkCategoryTabs(target);
    initHkMoCardsQueryFilter(target);
    initHkMoAnchorNav(target);

    if (target.querySelector('header-menu') || target.closest('#header-component')) {
      overflowInitRetries = 0;
      window.setTimeout(initOverflowMenuHoverKeep, 0);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var detail = event.detail;
    if (!detail || !detail.load) return;

    var target = /** @type {HTMLElement} */ (event.target);
    var section = target.closest('.shopify-section') || target;
    initHkGridGroupCarousels(section);
    initHkButtonSvgRecolor(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeCustom);
  } else {
    initThemeCustom();
  }
})();
